import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import ScreenHeader from '../components/ScreenHeader';
import { localAxios } from '../api';

const SITE_NAMES = { 1: 'Ruby Hill', 2: 'McCoy Cove', 3: 'Lone Tree', 4: 'Granite Creek' };

export default function GuardianConfirm() {
    const navigate = useNavigate();
    const { data: meResponse,    isLoading: meLoading }     = useSWR('/api/me', localAxios);
    const { data: minorResponse, isLoading: minorsLoading } = useSWR('/api/guardian/minors', localAxios);
    const minorList = minorResponse?.data ?? [];
    const me = meResponse?.data;

    const [checked, setChecked] = useState({});
    const [atTop,    setAtTop]    = useState(true);
    const [atBottom, setAtBottom] = useState(false);
    const listRef = useRef(null);

    const siteId = minorList.find(m => m.site_id)?.site_id;

    useEffect(() => {
        if (minorList.length > 0) {
            const init = {};
            minorList.forEach((_, i) => { init[i] = true; });
            setChecked(init);
        }
    }, [minorList.length]);

    useEffect(() => {
        const el = listRef.current;
        if (!el) return;
        const check = () => {
            setAtTop(el.scrollTop <= 1);
            setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
        };
        check();
        el.addEventListener('scroll', check);
        return () => el.removeEventListener('scroll', check);
    }, [minorList.length]);

    useEffect(() => {
        if (siteId) {
            localAxios.post('/api/workflow-state', { step: 'guardian-confirm', site_id: siteId })
                .catch((err) => console.log('Error saving workflow state:', err));
        }
    }, [siteId]);

    if (meLoading || minorsLoading) return null;

    const toggle = (i) => setChecked(prev => ({ ...prev, [i]: !prev[i] }));

    const confirmedMinors   = minorList.filter((_, i) =>  !!checked[i]);
    const unconfirmedMinors = minorList.filter((_, i) => !checked[i]);
    const siteName = SITE_NAMES[siteId];

    const handleConfirm = () => {
        if (siteName) {
            navigate(`/acknowledge/${encodeURIComponent(siteName)}`, {
                state: { confirmedMinors, unconfirmedMinors },
            });
        } else {
            navigate('/choose');
        }
    };

    return (
        <div className="app-wide__container">
            <ScreenHeader message="Guardian Confirmation" />
            <div className="app-wide__add-new">
                <div className="guardian-badge">
                    <span className="guardian-badge__label">Guardian</span>
                    <span className="guardian-badge__name">
                        {me?.first_name} {me?.last_name}
                    </span>
                </div>
                <p style={{ margin: '12px 16px 0', fontSize: '15px', color: '#555' }}>
                    The following minor(s) are registered under your care for this visit.
                    Check the ones you are acknowledging. Uncheck any you disagree with, or uncheck all.
                </p>
            </div>
            <div className="app-wide__main">
                {minorList.length === 0 ? (
                    <p style={{ textAlign: 'center', color: '#888', marginTop: '24px' }}>
                        No minors found associated with your account.
                    </p>
                ) : (
                    <ul
                        ref={listRef}
                        className="guardian-confirm__minor-list"
                        style={{
                            maskImage: (atTop && atBottom)
                                ? 'none'
                                : atTop
                                    ? 'linear-gradient(to bottom, black 70%, transparent 100%)'
                                    : atBottom
                                        ? 'linear-gradient(to bottom, transparent 0%, black 30%)'
                                        : 'linear-gradient(to bottom, transparent 0%, black 15%, black 85%, transparent 100%)',
                            WebkitMaskImage: (atTop && atBottom)
                                ? 'none'
                                : atTop
                                    ? 'linear-gradient(to bottom, black 70%, transparent 100%)'
                                    : atBottom
                                        ? 'linear-gradient(to bottom, transparent 0%, black 30%)'
                                        : 'linear-gradient(to bottom, transparent 0%, black 15%, black 85%, transparent 100%)',
                        }}
                    >
                        {minorList.map((minor, i) => (
                            <li key={i} className="visit-submitted__person">
                                <label style={{
                                    display: 'flex', alignItems: 'center',
                                    gap: '12px', cursor: 'pointer', flex: 1, margin: 0,
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={!!checked[i]}
                                        onChange={() => toggle(i)}
                                        style={{ width: '17px', height: '17px', cursor: 'pointer', flexShrink: 0 }}
                                    />
                                    <span className="visit-submitted__person-name">
                                        {minor.first_name} {minor.last_name}
                                    </span>
                                    {minor.organization && (
                                        <span className="visitor-tag visit-submitted__role-tag">
                                            {minor.organization}
                                        </span>
                                    )}
                                </label>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className="app-wide__footer">
                <div className="formButtons">
                    <button className="button save" onClick={handleConfirm}>
                        Confirm &amp; Continue
                    </button>
                </div>
            </div>
        </div>
    );
}
